import { render } from "./AppTabGroup.vue?vue&type=template&id=55c6b937&scoped=true"
import script from "./AppTabGroup.vue?vue&type=script&lang=js"
export * from "./AppTabGroup.vue?vue&type=script&lang=js"

import "./AppTabGroup.vue?vue&type=style&index=0&id=55c6b937&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c6b937"]])

export default __exports__